import React from 'react';
import SidebarNav from './SidebarNav';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const DesktopSideMenu = ({ menuItems, activeItemText }) => {
    const { logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = () => {
        console.log('Logging out from DesktopSideMenu...'); // Added console log here
        logout();
        navigate('/login');
    };
    return (
        <nav id="sidebarMenu" className="col-md-3 col-lg-2 d-md-block bg-white sidebar collapse">
            <div className="position-sticky pt-3">
                <SidebarNav menuItems={menuItems} activeItemText={activeItemText} />
                <div className="mt-5 px-3">
                    <button className="btn btn-checkin px-0 w-100" onClick={handleLogout}>Cerrar sesión</button>
                </div>
            </div>
        </nav>
    );
};

export default DesktopSideMenu;